<template>
  <div>
  <v-layout>
    <v-flex xs12 sm10 offset-sm1 >
      <v-card>
        <v-card-title class="primary justify-center" >
          <v-flex sm12>
           <h6 class="white--text text-xs-center">Clientes</h6>
          </v-flex>
            <v-flex xs12 sm12>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-select v-bind:items="dias" v-model="dia" dark
                            label="Día:" itemText="text" itemValue="value" @change="filtrardia($event)"></v-select>
                </v-flex>
                <v-flex xs12 sm3>
                   <v-select v-bind:items="semanas" v-model="semana" dark @change="filtrarsemana($event)"
                            label="Semana:" itemText="text" itemValue="value"></v-select>
                </v-flex>
                 <v-flex xs12 sm3>
                    <v-select
                      v-bind:items="rutas"
                      v-model="ruta"
                      itemText="nombre"
                      label="Rutas"
                      single-line
                      bottom
                      dark
                      @change="filtrarruta($event)"
                    >
                    </v-select>
                </v-flex>
                <v-flex sm3>
                   <v-text-field
                    dark
                    name="input-1"
                    prepend-icon="search"
                    label-icon="search"

                    v-model="busqueda"
                    @keyup="buscar"
                  ></v-text-field>
                </v-flex>
                <v-flex justify="space-between">
                   <v-btn
                  absolute
                  dark
                  small
                  fab
                  button
                  right
                  class="accent"
                  @click.native="dialog = true"
                >
              <v-icon>add</v-icon>
            </v-btn>
                <v-btn
                  absolute
                  dark
                  small
                  fab
                  button
                  center
                  class="blue"
                  v-if="!editarorden"
                  @click.native="editarorden = !editarorden"
                >
              <v-icon>edit</v-icon>
            </v-btn>
                  <v-btn
                  absolute
                  dark
                  small
                  fab
                  button
                  center
                  class="red"
                  v-if="editarorden"
                  @click.native="editarorden = !editarorden"
                  @click="guardartodo"
                >
              <v-icon>save</v-icon>
            </v-btn>

                </v-flex>

              </v-layout>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout>
              <v-flex style="overflow-x: auto" xs12>
                <table class="table">
                  <thead>
                    <th class="pa-0 ma-0"></th>
                    <th class="pa-0 ma-0"></th>
                    <td v-show="editarorden">nuevo</td>
                    <th>Cliente</th>
                    <th>Direccion</th>
                    <th>Código</th>
                    <th>ultima compra</th>
                    <th>deuda</th>
                    <th>Orden</th>
                    <th>Ubicacion</th>
                  </thead>
                  <tbody class="ma-0 pa-0">
                    <tr v-for="cliente in clientes.results">
                      <td class="text-xs-left pa-0">
                        <v-btn icon class="red--text text--darken-2 btn--small" @click="eliminar(cliente) " pa-0 ma-0>
                          <v-icon>delete</v-icon>
                        </v-btn></td>
                      <td class="text-xs-left pa-0">
                        <v-btn icon class="blue--text text--darken-2 " @click="editar(cliente)">
                          <v-icon>edit</v-icon>
                        </v-btn></td>
                      <td class="text-xs-center text-xs-left pa-0 ma-0" v-if="editarorden">
                        <v-text-field label="" singleLine=""  v-model="cliente.orden" @input = "guardarorden($event, cliente)"></v-text-field>
                      </td>
                      <td class="text-xs-center text-xs-left pa-0 " :class="cliente.malcliente? 'red--text': cliente.zero_last3 === 3?'orange--text': 'black--text'"    @click="crearfactura(cliente)">{{cliente.nombre}}</td>
                      <td class="text-xs-center text-xs-left pa-0 " :class="cliente.malcliente? 'red--text': cliente.zero_last3 ===3?'orange--text': 'black--text'" >{{cliente.direccion_completa}}</td>
                      <td class="text-xs-center text-xs-left pa-0">{{cliente.codigo}}</td>
                      <td class="text-xs-center text-xs-left pa-0 ma-0">{{cliente.ultima}}</td>
                      <td class="text-xs-center text-xs-left pa-0 ma-0 red--text" v-if="cliente.debe">{{cliente.total}}</td>
                      <td class="text-xs-center text-xs-left pa-0 ma-0" v-if="!cliente.debe">{{cliente.total}}</td>
                      <td class="text-xs-center text-xs-left pa-0 ma-0">{{cliente.orden}}</td>
                      <td class="text-xs-center text-xs-center pa-0 ma-0 blue--text" style="cursor: pointer" @click="actualizarubicacion(cliente.id)" v-if="cliente.estado_ubiacion"><v-icon color="blue" class="blue--text">place</v-icon></td>
                      <td class="text-xs-center text-xs-center pa-0 ma-0 red--text" style="cursor: pointer" @click="actualizarubicacion(cliente.id)" v-if="!cliente.estado_ubiacion"><v-icon color="red" class="red--text">place</v-icon></td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-layout row justify-center align-center>
             <v-btn fab dark small primary @click="prev(clientes.previous)" v-if="clientes.previous">
              <v-icon dark>skip_previous</v-icon>
            </v-btn>
             <v-btn fab dark small primary @click="next(clientes.next)" v-if="clientes.next">
            <v-icon>skip_next</v-icon>
          </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent="">
      <v-card>
        <v-card-title primary>
          <span class="headline"> Cliente </span>
        </v-card-title>
        <v-card-text>
          <v-text-field label="Nombre:" v-model="cliente.nombre" required singleLine=""></v-text-field>
          <v-text-field label="Nit:" v-model="cliente.nit" singleLine=""></v-text-field>
          <v-select v-bind:items="listaDepartamentos" v-model="cliente.departamento" label="Departamento:*" itemText="text" itemValue="value"></v-select>
          <v-select v-bind:items="municipios" v-model="cliente.municipio" label="Municipio:*" itemText="text" itemValue="value"></v-select>
          <v-text-field label="Avenida:" v-model="cliente.avenida" flat="solo"></v-text-field>
          <v-text-field label="Calle:" v-model="cliente.calle" flat="solo"></v-text-field>
          <v-select v-bind:items="zonas" v-model="cliente.zona" label="Zona:" itemText="text" itemValue="value"></v-select>
          <v-text-field label="Barrio o Aldea:" v-model="cliente.barrio_aldea" flat="solo"></v-text-field>
          <v-text-field label="Colonia o Caserío:" v-model="cliente.colonia_caserio" flat="solo"></v-text-field>
          <v-text-field label="Direccion:" v-model="cliente.direccion" flat="solo"></v-text-field>
          <v-text-field label="Referencia:" v-model="cliente.referencia" flat="solo"></v-text-field>
          <v-text-field label="Correo:" v-model="cliente.correo " type="email" singleLine=""></v-text-field>
          <v-text-field label="Teléfono:" v-model="cliente.telefono" type="tel" singleLine=""></v-text-field>
          <v-text-field label="Orden:" v-model="cliente.orden" singleLine=""></v-text-field>
          <v-select v-bind:items="dias" v-model="cliente.dia" label="Día:" itemText="text" itemValue="value"></v-select>
           <v-select v-bind:items="semanas" v-model="cliente.semana" label="Semana:" itemText="text" itemValue="value"></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="cerrar">Cerrar</v-btn>
          <v-btn class="blue--text darken-1" flat @click="editarcliente" :disabled="!activadorcliente">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>
</div>
</template>

<script>
  export default {
    created: function () {
      this.$store.dispatch('getclientes')
      this.$store.dispatch('getrutas')
    },
    data: function () {
      return {
        depatamentos: [
          {
            'title': 'Alta Verapaz',
            'mun': [
              'Chahal',
              'Chisec',
              'Cobán',
              'Fray Bartolomé de las Casas',
              'Lanquín',
              'Panzós',
              'Raxruha',
              'San Cristóbal Verapaz',
              'San Juan Chamelco',
              'San Pedro Carchá',
              'Santa Cruz Verapaz',
              'Senahú',
              'Tactic',
              'Tamahú',
              'Tucurú',
              'Santa María Cahabón',
              'Santa Catarina La Tinta'
            ]},
          {
            'title': 'Baja Verapaz',
            'mun': [
              'Cubulco',
              'Granados',
              'Purulhá',
              'Rabinal',
              'Salamá',
              'San Jerónimo',
              'San Miguel Chicaj',
              'Santa Cruz El Chol'
            ]},
          {
            'title': 'Chimaltenango',
            'mun': [
              'Acatenango',
              'Chimaltenango',
              'El Tejar',
              'Parramos',
              'Patzicía',
              'Patzún',
              'Pochuta',
              'San Andrés Itzapa',
              'San José Poaquil',
              'San Juan Comalapa',
              'San Martín Jilotepeque',
              'Santa Apolonia',
              'Santa Cruz Balanyá',
              'Tecpán Guatemala',
              'Yepocapa',
              'Zaragoza'
            ]},
          {
            'title': 'Chiquimula',
            'mun': [
              'Camotán',
              'Chiquimula',
              'Concepción Las Minas',
              'Esquipulas',
              'Ipala',
              'Jocotán',
              'Olopa',
              'Quezaltepeque',
              'San Jacinto',
              'San José La Arada',
              'San Juan Ermita'
            ]},
          {
            'title': 'El Progreso',
            'mun': [
              'El Jícaro',
              'Guastatoya',
              'Morazán',
              'San Agustín Acasaguastlán',
              'San Antonio La Paz',
              'San Cristóbal Acasaguastlán',
              'Sanarate'
            ]},
          {
            'title': 'Escuintla',
            'mun': [
              'Escuintla',
              'Guanagazapa',
              'Iztapa',
              'La Democracia',
              'La Gomera',
              'Masagua',
              'Nueva Concepción',
              'Palín',
              'San José',
              'San Vicente Pacaya',
              'Santa Lucía Cotzumalguapa',
              'Siquinalá',
              'Tiquisate'
            ]},
          {
            'title': 'Guatemala',
            'mun': [
              'Amatitlán',
              'Chinautla',
              'Chuarrancho',
              'Fraijanes',
              'Guatemala City',
              'Mixco',
              'Palencia',
              'Petapa',
              'San José del Golfo',
              'San José Pinula',
              'San Juan Sacatepéquez',
              'San Pedro Ayampuc',
              'San Pedro Sacatepéquez',
              'San Raymundo',
              'Santa Catarina Pinula',
              'Villa Canales'
            ]},
          {
            'title': 'Huehuetenango',
            'mun': [
              'Aguacatán',
              'Chiantla',
              'Colotenango',
              'Concepción Huista',
              'Cuilco',
              'Huehuetenango',
              'Ixtahuacán',
              'Jacaltenango',
              'La Democracia',
              'La Libertad',
              'Malacatancito',
              'Nentón',
              'San Antonio Huista',
              'San Gaspar Ixchil',
              'San Juan Atitán',
              'San Juan Ixcoy',
              'San Mateo Ixtatán',
              'San Miguel Acatán',
              'San Pedro Necta',
              'San Rafael La Independencia',
              'San Rafael Petzal',
              'San Sebastián Coatán',
              'San Sebastián Huehuetenango',
              'Santa Ana Huista',
              'Santa Bárbara',
              'Santa Cruz Barillas',
              'Santa Eulalia',
              'Santiago Chimaltenango',
              'Soloma',
              'Tectitán',
              'Todos Santos Cuchumatan'
            ]},
          {
            'title': 'Izabal',
            'mun': [
              'El Estor',
              'Livingston',
              'Los Amates',
              'Morales',
              'Puerto Barrios'
            ]},
          {
            'title': 'Jalapa',
            'mun': [
              'Jalapa',
              'Mataquescuintla',
              'Monjas',
              'San Carlos Alzatate',
              'San Luis Jilotepeque',
              'San Manuel Chaparrón',
              'San Pedro Pinula'
            ]},
          {
            'title': 'Jutiapa',
            'mun': [
              'Agua Blanca',
              'Asunción Mita',
              'Atescatempa',
              'Comapa',
              'Conguaco',
              'El Adelanto',
              'El Progreso',
              'Jalpatagua',
              'Jerez',
              'Jutiapa',
              'Moyuta',
              'Pasaco',
              'Quezada',
              'San José Acatempa',
              'Santa Catarina Mita',
              'Yupiltepeque',
              'Zapotitlán'
            ]},
          {
            'title': 'Petén',
            'mun': [
              'Dolores',
              'Flores',
              'La Libertad',
              'Melchor de Mencos',
              'Poptún',
              'San Andrés',
              'San Benito',
              'San Francisco',
              'San José',
              'San Luis',
              'Santa Ana',
              'Sayaxché',
              'Las Cruces'
            ]},
          {
            'title': 'Quetzaltenango',
            'mun': [
              'Almolonga',
              'Cabricán',
              'Cajolá',
              'Cantel',
              'Coatepeque',
              'Colomba',
              'Concepción Chiquirichapa',
              'El Palmar',
              'Flores Costa Cuca',
              'Génova',
              'Huitán',
              'La Esperanza',
              'Olintepeque',
              'Ostuncalco',
              'Palestina de Los Altos',
              'Quetzaltenango',
              'Salcajá',
              'San Carlos Sija',
              'San Francisco La Unión',
              'San Martín Sacatepéquez',
              'San Mateo',
              'San Miguel Sigüilá',
              'Sibilia',
              'Zunil'
            ]},
          {
            'title': 'Quiché',
            'mun': [
              'Canillá',
              'Chajul',
              'Chicamán',
              'Chiché',
              'Chichicastenango',
              'Chinique',
              'Cunén',
              'Ixcán',
              'Joyabaj',
              'Nebaj',
              'Pachalum',
              'Patzité',
              'Sacapulas',
              'San Andrés Sajcabajá',
              'San Antonio Ilotenango',
              'San Bartolomé Jocotenango',
              'San Juan Cotzal',
              'San Pedro Jocopilas',
              'Santa Cruz del Quiché',
              'Uspantán',
              'Zacualpa'
            ]},
          {
            'title': 'Retalhuleu',
            'mun': [
              'Champerico',
              'El Asintal',
              'Nuevo San Carlos',
              'Retalhuleu',
              'San Andrés Villa Seca',
              'San Felipe',
              'San Martín Zapotitlán',
              'San Sebastián',
              'Santa Cruz Muluá'
            ]},
          {
            'title': 'Sacatepéquez',
            'mun': [
              'Alotenango',
              'Antigua',
              'Ciudad Vieja',
              'Jocotenango',
              'Magdalena Milpas Altas',
              'Pastores',
              'San Antonio Aguas Calientes',
              'San Bartolomé Milpas Altas',
              'San Lucas Sacatepéquez',
              'San Miguel Dueñas',
              'Santa Catarina Barahona',
              'Santa Lucía Milpas Altas',
              'Santa María de Jesús',
              'Santiago Sacatepéquez',
              'Santo Domingo Xenacoj',
              'Sumpango'
            ]},
          {
            'title': 'San Marcos',
            'mun': [
              'Ayutla',
              'Catarina',
              'Comitancillo',
              'Concepción Tutuapa',
              'El Quetzal',
              'El Rodeo',
              'El Tumbador',
              'Esquipulas Palo Gordo',
              'Ixchiguan',
              'La Reforma',
              'Malacatán',
              'Nuevo Progreso',
              'Ocos',
              'Pajapita',
              'Río Blanco',
              'San Antonio Sacatepéquez',
              'San Cristóbal Cucho',
              'San José Ojetenam',
              'San Lorenzo',
              'San Marcos',
              'San Miguel Ixtahuacán',
              'San Pablo',
              'San Pedro Sacatepéquez',
              'San Rafael Pie de La Cuesta',
              'San Sibinal',
              'Sipacapa',
              'Tacaná',
              'Tajumulco',
              'Tejutla'
            ]},
          {
            'title': 'Santa Rosa',
            'mun': [
              'Barberena',
              'Casillas',
              'Chiquimulilla',
              'Cuilapa',
              'Guazacapán',
              'Nueva Santa Rosa',
              'Oratorio',
              'Pueblo Nuevo Viñas',
              'San Juan Tecuaco',
              'San Rafael Las Flores',
              'Santa Cruz Naranjo',
              'Santa María Ixhuatán',
              'Santa Rosa de Lima',
              'Taxisco'
            ]},
          {
            'title': 'Sololá',
            'mun': [
              'Concepción',
              'Nahualá',
              'Panajachel',
              'San Andrés Semetabaj',
              'San Antonio Palopó',
              'San José Chacaya',
              'San Juan La Laguna',
              'San Lucas Tolimán',
              'San Marcos La Laguna',
              'San Pablo La Laguna',
              'San Pedro La Laguna',
              'Santa Catarina Ixtahuacan',
              'Santa Catarina Palopó',
              'Santa Clara La Laguna',
              'Santa Cruz La Laguna',
              'Santa Lucía Utatlán',
              'Santa María Visitación',
              'Santiago Atitlán',
              'Sololá'
            ]},
          {
            'title': 'Suchitepéquez',
            'mun': [
              'Chicacao',
              'Cuyotenango',
              'Mazatenango',
              'Patulul',
              'Pueblo Nuevo',
              'Río Bravo',
              'Samayac',
              'San Antonio Suchitepéquez',
              'San Bernardino',
              'San Francisco Zapotitlán',
              'San Gabriel',
              'San José El Idolo',
              'San Juan Bautista',
              'San Lorenzo',
              'San Miguel Panán',
              'San Pablo Jocopilas',
              'Santa Bárbara',
              'Santo Domingo Suchitepequez',
              'Santo Tomas La Unión',
              'Zunilito'
            ]},
          {
            'title': 'Totonicapán',
            'mun': [
              'Momostenango',
              'San Andrés Xecul',
              'San Bartolo',
              'San Cristóbal Totonicapán',
              'San Francisco El Alto',
              'Santa Lucía La Reforma',
              'Santa María Chiquimula',
              'Totonicapán'
            ]},
          {
            'title': 'Zacapa',
            'mun': [
              'Cabañas',
              'Estanzuela',
              'Gualán',
              'Huité',
              'La Unión',
              'Río Hondo',
              'San Diego',
              'Teculután',
              'Usumatlán',
              'Zacapa'
            ]
          }
        ],
        ordenes: [],
        editarorden: false,
        dias: [{text: 'Todos', value: ''}, {text: '1', value: 1},
          {text: '2', value: 2}, {text: '3', value: 3},
        {text: '4', value: 4}, {text: '5', value: 5},
          {text: '6', value: 6} ],
        semanas: [{text: 'Todos', value: ''}, {text: 'Semana1', value: 1},
          {text: 'Semana2', value: 2}, {text: 'Semana3', value: 3},
        {text: 'Semana4', value: 4}],
        busqueda: '',
        errorClass: 'text-danger'
      }
    },
    methods: {
      actualizarubicacion: function (id) {
        this.$router.push('/clientes/ubicacion/' + id)
      },
      guardarorden: function (envent, cliente) {
        let index = this.ordenes.indexOf(cliente)
        if (index === -1) {
          this.ordenes.push(cliente)
        } else {
          this.ordenes[index] = cliente
        }
      },
      guardartodo: function () {
        this.ordenes.forEach(dato => {
          this.$store.dispatch('editarcliente', dato, false)
        })
        alert('Modificado Exitosamente')
      },
      eliminar: function (dato) {
        let a = confirm('Desea eliminar a  ' + dato.nombre)
        if (a) {
          this.$store.dispatch('eliminarcliente', dato)
        }
      },
      crearfactura: function (cliente) {
        this.$store.commit('actualizarcliente', cliente)
        this.$store.dispatch('crearfactura', cliente.id)
      },
      filtrardia: function (event) {
        this.$store.commit('actualizardia', event)
        this.$store.dispatch('filter', { 'dia': this.dia, 'semana': this.semana, ruta: this.ruta.nombre })
      },
      filtrarsemana: function (event) {
        this.$store.commit('actualizarsemana', event)
        this.$store.dispatch('filter', { 'dia': this.dia, 'semana': event, ruta: this.ruta.nombre })
      },
      filtrarruta: function (event) {
        this.$store.commit('actualizarruta', event)
        this.$store.dispatch('filter', { 'dia': this.dia, 'semana': this.semana, ruta: this.ruta.nombre })
      },
      buscar: function () {
        this.$store.dispatch('filter', { search: this.busqueda })
      },
      editar: function (dato) {
        this.$store.commit('actualizarcliente', dato)
        this.$store.commit('actualizardialog', true)
      },
      next: function (dato) {
        this.$store.dispatch('getclientes', dato)
      },
      prev: function (dato) {
        this.$store.dispatch('getclientes', dato)
      },
      editarcliente: function () {
        if (!this.$store.getters.cliente.municipio || !this.$store.getters.cliente.departamento) {
          alert('El departamento y el municipio es obligatorio')
        } else {
          this.$store.commit('setactivadorcliente', true)
          if (this.$store.getters.cliente.id) {
            this.$store.dispatch('editarcliente', this.$store.getters.cliente, true)
          } else {
            let dato = this.$store.getters.cliente
            if (this.ruta) {
              dato['ruta'] = this.ruta.id
            }
            this.$store.dispatch('crearcliente', dato)
          }
        }
      },
      cerrar: function () {
        this.$store.commit('actualizardialog', false)
        this.$store.commit('limpiarcliente')
      }
    },
    computed: {
      rutas: function () {
        return this.$store.getters.rutas
      },
      ruta: {
        get: function () {
          return this.$store.getters.getruta
        },
        set: function (dato) {
          this.$store.commit('actualizarruta', dato)
        }
      },
      clientes: function () {
        return this.$store.getters.clientes
      },
      cliente: function () {
        return this.$store.getters.cliente
      },
      dialog: {
        get: function () {
          return this.$store.getters.dialogo
        },
        set: function (dato) {
          this.$store.commit('actualizardialog', dato)
        }
      },
      dia: function () {
        return this.$store.getters.getdia
      },
      semana: function () {
        return this.$store.getters.getsemana
      },
      activadorcliente: function () {
        return this.$store.getters.getactivadorcliente
      },
      municipios () {
        const departamento = this.depatamentos.find(
          d => d.title === this.cliente.departamento)
        if (!departamento) return []
        return departamento.mun.map(m => ({ text: m, value: m }))
      },
      listaDepartamentos () {
        return this.depatamentos.map(dep => ({ text: dep.title, value: dep.title }))
      },
      zonas () {
        const lista = []
        for (let i = 1; i <= 30; i++) {
          lista.push({
            text: `Zona ${i}`,
            value: `zona ${i}` // puedes usar solo el número si lo prefieres: value: i
          })
        }
        return lista
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Cliente.vue?12f5eb42